import {LOGIN, LOGOUT, SET_ENTITLEMENTS} from "../actions/auth"

const initailState = {
    token: sessionStorage.getItem("token"),
    isLoggedIn: sessionStorage.getItem("isLoggedIn") === 'true',
    role: sessionStorage.getItem("role") ? JSON.parse(sessionStorage.getItem("role")) : null,
    user: sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user")) : null,
    entitlements: sessionStorage.getItem("entitlements") ? JSON.parse(sessionStorage.getItem("entitlements")) : null
}


export default (state = initailState, action) => {
    // console.log('[AUTH_REDUCER] Action received:', action.type);
    switch (action.type) {
        case LOGIN:
            // console.log('[AUTH_REDUCER] Processing LOGIN');
            var newState = {...state}
            newState.isLoggedIn = true;
            sessionStorage.setItem("isLoggedIn", 'true')
            newState.token = action.token;
            sessionStorage.setItem("token", action.token)
            newState.role = action.role || null;
            sessionStorage.setItem("role", JSON.stringify(newState.role))
            newState.user = action.user || null;
            sessionStorage.setItem("user", JSON.stringify(newState.user))
            // console.log('[AUTH_REDUCER] LOGIN complete, isLoggedIn:', newState.isLoggedIn);
            return newState;

        case SET_ENTITLEMENTS:
            var entitlementsState = {...state}
            entitlementsState.entitlements = action.entitlements || null;
            sessionStorage.setItem("entitlements", JSON.stringify(entitlementsState.entitlements))
            return entitlementsState;
        
        case LOGOUT:
            console.log('[AUTH_REDUCER] Processing LOGOUT');
            var newState = {...state}
            newState.isLoggedIn = false;
            newState.token = null;
            newState.role = null;
            newState.entitlements = null;
            console.log('[AUTH_REDUCER] Clearing sessionStorage');
            sessionStorage.clear();
            console.log('[AUTH_REDUCER] LOGOUT complete');
            return newState;
            
        default:
            return state;     
    }
}